import React from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import $ from "jquery";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import CatalogusGebruikers from "./modals/catalogusGebruikers";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gebruikers: [],
    };
  }
  handleModalGebruikers = async () => {
    let result = await omnimap.GetRelationAction(
      window.$catalog_area_selectedRow.identification,
      1,
      30,
      window.$catalog_management_units_token
    );
    if(result.data){
      await this.setState({
        gebruikers: result.data.filter((m) => m.role === "Gebied gebruiker"),
      });
    }

    $("#gebieden-catalogus-gebruikers").modal("show");
  };
  async componentDidMount() {
    $(".back-page-link").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
    });
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
    });
    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });
  }

  render() {
    return (
      <div id="detailSide" className="d-none">
        <div className="detail-title">Gebied in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a id="detail-button" className="back-page-link" role="button">
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Gebieden
            </a>
          </div>
          <div className="float-right mt-0">
            <a id="edit-button" className="button bewerken">
              Bewerken
            </a>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam</div>
              <div className="box-title-2-active" id="area-naam" />
              <span
                className="tooltiptext detail"
                id="area-naam-tooltip"
              ></span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code</div>
              <div className="box-title-2" id="area-code" />
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Omschrijving</div>
              <div className="box-title-2" id="area-omschrijving" />
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-2 text-center">
            <div className="box-detail">
              <div className="box-title-1">Gebruikers</div>
              <a role="button" onClick={this.handleModalGebruikers.bind(this)}>
                <div className="box-title-2 gebruikers-ico" id="d-gebruikers" />
              </a>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Discipline naam</div>
              <div className="box-title-2" id="area-discipline-naam" />
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">actief</div>
              <label className="switch">
                <input id="area-active" type="checkbox" disabled />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
        <CatalogusGebruikers gebruikers={this.state.gebruikers} />
      </div>
    );
  }
}

export default Detail;
